import React from 'react';
import { connect } from 'react-redux';
import AsyncSelect from "react-select/async";
import axios from 'axios';
import ErrorValidation from '../../../services/ErrorValidation';
import Ax from '../../../components/hoc/Ax';
import ReactSelectStyle from '../../../components/ui/ReactSelectStyle';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import api from '../../../services/api';

class InputProjectSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedProject: null,
            timer: false,
            defaultOptions: [],
        };
        this.cancelToken = null;
        this.apiTimeout = null;
    }

    initParams = (props) => {
        this.setState({
            params: {
                search_site: props.search_site_id || '',
            }
        }, () => {
            if (this.props.loadDefaultOptions) {
                this.getDefaultOptions();
            }
        });
    }

    componentDidMount() {
        this.initParams(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.search_site_id !== this.props.search_site_id) {
            this.initParams(nextProps);
        }
    }

    onInputChange = (selectedOption) => {
        this.props.changeEvent(selectedOption);
    }

    displayStringSearch = (projects) => {
        const projectList = Array.isArray(projects) ? projects : [];
        return projectList.map(project => {
            return {
                label: (
                    <Ax>
                        <b>Project Name: </b> {project.name} <br />
                        <b>Transaction ID: </b> {project.transaction_id} <br />
                        <b>Status: </b> {project.status.status} <br />
                        <b>Site: </b> {project.site.site_name} ({project.site.site_code})
                    </Ax>
                ),
                value: project.id, 
                display_label: `${project.name} (${project.transaction_id})`,
                project: project
            };
        });
    };

    loadingOptions = (inputText, callback) => {
        if (inputText.length > 2) {
            clearTimeout(this.apiTimeout);
            if (this.cancelToken) {
                this.cancelToken.cancel("Operation canceled due to new request.");
            }
            this.cancelToken = axios.CancelToken.source();

            let params = { ...this.state.params, search_by_text: inputText, per_page: 50 };

            this.apiTimeout = setTimeout(() => { this.getLoadingOptions(params, callback) }, 1000);
        }
    }

    getLoadingOptions = (params, callback) => {
        api.server2Api({
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + this.props.access_token },
            params: params,
            url: IAM_API_BASE_URL_2 + '/project/list',
            cancelToken: this.cancelToken.token
        })

            .then((response) => {
            callback(this.displayStringSearch(response.data.data));
        }).catch((err) => {
            if (axios.isCancel(err)) {
                // Request was canceled
            } else {
                console.error("API Error:", err.response ? err.response.data : err.message);
                ErrorValidation.apiErrorHandle(err, 'Unable to Get / Save Application Data.');
            }
        });
    }

    getDefaultOptions = () => {
        this.setState({ defaultOptions: [] });
          HttpAPICall.withAthorization('GET',  IAM_API_BASE_URL_2 + '/project/list', this.props.access_token,   this.state.params, {})
        .then((response) => {
            this.setState({
                defaultOptions: this.displayStringSearch(response.data.data)
            });
        }).catch((err) => {
            if (axios.isCancel(err)) {
                // Request was canceled
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get / Save Application Data.');
            }
        });
    }

    render() {
        return (
            <Ax>
                <AsyncSelect
                    styles={ReactSelectStyle(this.props)}
                    menuPlacement={this.props.menuPlacement || "bottom"}
                    placeholder={this.props.placeholder || "Search Project by Name, Transaction ID, or Site"}
                    loadingMessage={(input) => {
                        if (input.inputValue && input.inputValue.length <= 2) {
                            return 'Please enter 3 or more characters';
                        } else {
                            return 'Searching...';
                        }
                    }}
                    noOptionsMessage={(input) => {
                        if (input.inputValue.length === 0) {
                            return 'Please enter 3 or more characters';
                        } else {
                            return 'No Project found';
                        }
                    }}
                    minimumInput={5}
                    complete={true}
                    onChange={this.onInputChange}
                    isClearable={this.props.isClearable || true}
                    loadOptions={this.loadingOptions}
                    value={this.props.value}
                    isMulti={this.props.isMulti || false}
                    required={true}
                    isDisabled={this.props.disabled || false}
                    defaultOptions={this.props.loadDefaultOptions ? this.state.defaultOptions : null}
                />
                <input
                    name=''
                    tabIndex={-1}
                    required={this.props.required || false}
                    value={this.props.isMulti ? (this.props.value.length > 0 ? this.props.value[0].label : '') : (this.props.value ? this.props.value.label : '')}
                    onChange={() => { }}
                    style={{
                        opacity: 0,
                        width: 0,
                        height: 0,
                        padding: 0,
                        margin: 0,
                        display: 'table'
                    }}
                />
            </Ax>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token
    };
};

export default connect(mapStateToProps)(InputProjectSearch);



